import { PageLayoutDefaultContainer, PageLayoutDefaultMenuNavigationItem } from "@sis/react-library"
import { LayoutTopAppBarLeft } from "./LayoutTopAppBarLeft"
import { LayoutTopAppBarRight } from "./LayoutTopAppBarRight"
import { LayoutFooter } from "./LayoutFooter"
import { useLocation, useNavigate } from "react-router-dom"
import { formSamplesRoutes, FormSamplesMenuItem } from "../formSamples/FormSamplesNavigation"
import { useEffect } from "react"
import { commonRoutes } from "../shared/commonRoutes"
import { ListAndDetailsSamplesMenuItem } from '../listAndDetailSamples/ListAndDetailSamplesNavigation';
import { OtherSamplesMenuItem } from "../otherSamples/OtherSamplesNavigation"

/////////////////////////////////////////////////////////////////////////////////////
// Uncomment below when showcasing different menu types
/////////////////////////////////////////////////////////////////////////////////////
// import ListIcon from '@mui/icons-material/List';
// import TextSnippetIcon from '@mui/icons-material/TextSnippet';
// import { listAndDetailSamplesRoutes } from '../listAndDetailSamples/ListAndDetailSamplesNavigation';

export const LayoutContainer = () => {

    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        // Make the initial page Form About
        if (location.pathname === commonRoutes.home) {
            navigate(formSamplesRoutes.about, { replace: true });
        }
    }, [location, navigate])

    const menuNavigationList: PageLayoutDefaultMenuNavigationItem[] = [
        // Try decouple your the LayoutContainer.tsx component from specific menu items.
        // The LayoutContainer.tsx should know what types of lists there is, but not the details.
        // In this example the LayoutContainer.tsx knows theres FormSamplesMenus, ListAndDetailSampleMenus, etc.
        // If changes need to be made to the menus of Forms for example the LayoutContainer.tsx component is not affected at all.
        { ...FormSamplesMenuItem },
        { ...ListAndDetailsSamplesMenuItem },
        { ...OtherSamplesMenuItem }
    ]

    //////////////////////////////////////////////////////////////////////////////////////////
    // Your menu can have no groupings
    // Comment out the list above and uncomment the list below to showcase.
    // (also uncomment the icons at the top of this file for showcasing)
    //////////////////////////////////////////////////////////////////////////////////////////    
    // const menuNavigationList: PageLayoutDefaultMenuNavigationItem[] = [
    //     { icon: <TextSnippetIcon />, text: 'Form Basic', navigateTo: formSamplesRoutes.about, selectedBackground: 'linear-gradient(to bottom right, rgb(0, 255, 0), rgb(0, 155, 0))', hoverBackground: 'linear-gradient(to bottom right, rgb(200, 255, 200), rgb(100, 155, 100))' },
    //     { icon: <ListIcon />, text: 'List And Detail Basic', navigateTo: listAndDetailSamplesRoutes.basic, selectedBackground: 'linear-gradient(to bottom right, rgb(0, 255, 0), rgb(0, 155, 0))', hoverBackground: 'linear-gradient(to bottom right, rgb(200, 255, 200), rgb(100, 155, 100))' },
    // ]

    //////////////////////////////////////////////////////////////////////////////////////////
    // Your menu icons can be different colours
    // Comment out the list above and uncomment the list below to showcase.
    // (also uncomment the icons at the top of this file for showcasing)
    //////////////////////////////////////////////////////////////////////////////////////////    
    // const menuNavigationList: PageLayoutDefaultMenuNavigationItem[] = [
    //     { icon: <TextSnippetIcon sx={{color:'orange'}} />, text: 'Form Basic', navigateTo: formSamplesRoutes.about },
    //     { icon: <ListIcon sx={{color:'yellow'}} />, text: 'List And Detail Basic', navigateTo: listAndDetailSamplesRoutes.basic },
    // ]

    //////////////////////////////////////////////////////////////////////////////////////////
    // You can have a mix of group and non group items
    // Comment out the list above and uncomment the list below to showcase.
    // (also uncomment the icons at the top of this file for showcasing)
    //////////////////////////////////////////////////////////////////////////////////////////
    // const menuNavigationList: PageLayoutDefaultMenuNavigationItem[] = [
    //     { text: 'About page', navigateTo: formSamplesRoutes.about },
    //     {
    //         icon: <TextSnippetIcon />, text: 'Form', items: [
    //             { text: 'Basic', navigateTo: formSamplesRoutes.basic },
    //             { text: 'Initial Values', navigateTo: formSamplesRoutes.initialValues },
    //         ]
    //     },
    //     {
    //         icon: <ListIcon />, text: 'List and Detail', items: [
    //             { text: 'Basic', navigateTo: listAndDetailSamplesRoutes.basic }
    //         ]
    //     }
    // ]

    //////////////////////////////////////////////////////////////////////////////////////////
    // You can also overwrite the text colour
    // Comment out the list above and uncomment the list below to showcase.
    // (also uncomment the icons at the top of this file for showcasing)
    //////////////////////////////////////////////////////////////////////////////////////////
    // const menuNavigationList: PageLayoutDefaultMenuNavigationItem[] = [
    //     {
    //         icon: <TextSnippetIcon />, text: 'Form', textColour: 'orange', items: [
    //             { text: 'About page', textColour: 'lightblue', navigateTo: formSamplesRoutes.about },
    //             { text: 'Basic', textColour: 'lightgreen', navigateTo: formSamplesRoutes.basic },
    //         ]
    //     },
    //     {
    //         icon: <ListIcon />, text: 'List and Detail', textColour: 'yellow', items: [
    //             { text: 'Basic', textColour: 'red', navigateTo: listAndDetailSamplesRoutes.basic }
    //         ]
    //     }
    // ]

    //////////////////////////////////////////////////////////////////////////////////////////
    // When collapsed and no icon, an avatar is created.
    // The avatar text is automatically created based on the text. This can be overwritten.
    // The colour of the avatar can also be set. (else defaults to white)
    // Comment out the list above and uncomment the list below to showcase.
    // (also uncomment the icons at the top of this file for showcasing)
    //////////////////////////////////////////////////////////////////////////////////////////
    // const menuNavigationList: PageLayoutDefaultMenuNavigationItem[] = [
    //     {
    //         text: 'Form Basic', navigateTo: formSamplesRoutes.about,
    //         avatarText: 'F', avatarColour: 'blue', avatarBackground: 'orange'
    //     },
    //     { 
    //         text: 'List And Detail Basic', navigateTo: listAndDetailSamplesRoutes.basic,
    //         avatarText: 'L', avatarColour: 'green', avatarBackground: 'yellow'
    //     },
    // ]

    return (
        <PageLayoutDefaultContainer
            topAppBarLeft={<LayoutTopAppBarLeft />}
            topAppBarRight={<LayoutTopAppBarRight />}
            menuNavigationList={menuNavigationList}  // If no menuNavigationList or menuCustomRender is passed then no draw with menus is created
            footer={<LayoutFooter />}

            //////////////////////////////////////////////////////////////////////////////////////////////
            // Uncomment below if you don't want the menu to be collapsable
            //////////////////////////////////////////////////////////////////////////////////////////////
            //menuNotCollapsable

            //////////////////////////////////////////////////////////////////////////////////////////////
            // Uncomment below if you don't want the menu to be collapse completely (for desktop only)
            //////////////////////////////////////////////////////////////////////////////////////////////
            //menuCollapseFully

            //////////////////////////////////////////////////////////////////////////////////////////////
            // Uncomment below if you want to set the width of the menu (and not use the default)
            //////////////////////////////////////////////////////////////////////////////////////////////
            //menuWidth={400}

            //////////////////////////////////////////////////////////////////////////////////////////////////
            // You can also add your own menu render (only works if you don't pass a menuNavigationList prop)
            // Comment out menuNavigationList above and uncomment below to try out
            //////////////////////////////////////////////////////////////////////////////////////////////////
            // menuCustomRender={(isFullWidth) => 
            //     <div style={{padding:'10px'}}>
            //         {isFullWidth ? 'Menu item' : 'M'}
            //     </div>
            // }
        />
    )
}
